// NOTES
/**
 * DOCS:
 * https://alpinejs.dev/essentials/installation
 * 
 * STATE:
 * To grab state $store values inside JS:
 * Alpine.store('your_store_item').valueYouWant
 * Example value - Alpine.store('pid_7870').hasOdd
 * Example method - Alpine.store('pid_7870').updateHasOdd(true)
 * 
.*/

import Alpine from 'alpinejs'
import qsa from '../../helpers/qsa'
import sortProductsByOdd from '../shared/sortProductsByOdd'
import handleProductListViewed from '../shared/handleProductListViewed'
import { tooltipContent, aoColorClasses } from '../shared/aoSettings'
import {
  aoButtonViewed,
  aoButtonClicked,
  aoResultViewed,
  aoBannerClicked
} from '../tagular'

// If we need to call Alpine elsewhere (optional).
window.Alpine = Alpine

// Grab loaded product boxes.
const productBoxes = qsa('article.box')
const hasApprovalOdds = document.querySelector('[data-has-approval-odds]')
  ? true
  : false

const handleDisplayResults = () => {
  // Grab results from session storage.
  const results = JSON.parse(sessionStorage.getItem('approvalOdds'))
  // Add each product to store as it's own instance.
  for (const [key, value] of Object.entries(results.data.approvalOdds)) {
    if (Alpine.store(`pid_${key}`)) {
      // Set the approval odd value.
      Alpine.store(`pid_${key}`).updateOdd(value)
      // Tell state that this card now has an approval odd.
      Alpine.store(`pid_${key}`).updateHasOdd(true)
      Alpine.store(`pid_${key}`).updateTooltipContent(value)
      Alpine.store(`pid_${key}`).updateAoColor(value)
    }
  }

  // Update products array in approval_odds store.
  Alpine.store('approval_odds').products.forEach(product => {
    if (Alpine.store(`pid_${product.pid}`)) {
      product.odd = Alpine.store(`pid_${product.pid}`).odd
    }
  })

  // Sort products by Approval Odd if sortProducts is true
  if (Alpine.store('approval_odds').sortProducts) {
    Alpine.store('approval_odds').products.sort(sortProductsByOdd)
    // Grab parent container
    const cardsWrapper = document.querySelector('.cards-wrapper__inner')
    // Re-append using vanilla JS and not Alpine loop to keep base product box functionallity (tagular events, apply now, etc)
    Alpine.store('approval_odds').products.forEach(product => {
      cardsWrapper.appendChild(product.element)
    })
    // Scroll to top of cards.
    document.querySelector('#cards-wrapper').scrollIntoView()
  }

  // Fire product list viewed event
  handleProductListViewed(productBoxes)
  // Update approval odds store.
  Alpine.store('approval_odds').updateHasResults()
}

// ALPINE JS LOGIC - STATE VIA $STORE
// -----------------------------------

// Top level Alpine state useing $store.
Alpine.store('approval_odds', {
  hasResults: false,
  sortProducts: false,
  // set starting product order to the rendered card order from server.
  products: productBoxes.map(product => {
    const pid = product.getAttribute('data-product-id')
    return {
      pid,
      key: `pid_${pid}`,
      element: product,
      odd: null,
      toolTipContent: '',
      aoChanceColor: ''
    }
  }),
  handleDisplayResults,
  updateHasResults() {
    this.hasResults = true
  },
  tagular: {
    aoButtonViewed,
    aoButtonClicked,
    aoResultViewed,
    aoBannerClicked
  }
})

// Create Alpine state instance for each product PID with default values.
productBoxes.forEach(box => {
  const pid = box.getAttribute('data-product-id')
  Alpine.store(`pid_${pid}`, {
    hasOdd: false,
    odd: null,
    updateHasOdd(hasOdd) {
      this.hasOdd = hasOdd
    },
    updateOdd(odd) {
      this.odd = odd
      // Add data-beam attributes with odd value for product viewed/clicked events.
      box.setAttribute('data-beam-format-type', odd)
      qsa('[data-apply-button]', box).forEach(el => {
        el.setAttribute('data-format-type', odd)
      })
    },
    updateTooltipContent(odd) {
      this.toolTipContent = tooltipContent[odd]
    },
    updateAoColor(odd) {
      this.aoChanceColor = aoColorClasses[odd]
    }
  })
})

// Display results if they already exist in session storage.
// Grab results from session storage.
if (sessionStorage.getItem('approvalOdds') && hasApprovalOdds) {
  Alpine.store('approval_odds').handleDisplayResults()
}
